import React from 'react';
type Props = {
  src: string;
  alt: string;
  eager?: boolean;
  overlay?: 'bottom' | 'center' | 'full' | 'none';
  className?: string;
};
const overlays: Record<NonNullable<Props['overlay']>, string> = {
  bottom: 'bg-gradient-to-t from-[var(--ms-forest-deep)] via-[var(--ms-forest-deep)]/25 to-transparent',
  center: 'bg-[var(--ms-forest-deep)]/34',
  full: 'bg-gradient-to-b from-[var(--ms-forest-deep)]/65 via-transparent to-[var(--ms-forest-deep)]/78',
  none: ''
};

// Every image is requested immediately: hidden pinned scenes must still arrive before their cinematic transition.
export function SceneLayer({
  src,
  alt,
  overlay = 'full',
  className = ''
}: Props) {
  return <div className={`scene-camera absolute -inset-[4%] z-0 overflow-hidden bg-[var(--ms-forest-deep)] ${className}`} data-id="element-175" data-mp="2ovjjv4tepuyd">
      <img src={src} alt={alt} loading="eager" fetchPriority="high" decoding="async" className="scene-image block h-full w-full object-cover" data-id="element-176" data-mp="i527puo2rzem" />
      {overlay !== 'none' && <div className={`scene-grade absolute inset-0 ${overlays[overlay]}`} data-id="element-177" data-mp="3eqy8myzm8qlj" />}
    </div>;
}